export default "__VITE_ASSET__Dp83tYva__"